<a class="mail-attachment" [href]="attachmentSource" [download] target="_blank">
  <div class="icon">
    <span class="{{ getClassName() }}"></span>
  </div>
  <div class="info">
    <span class="fileName">{{ fileName }}</span>
    <span class="fileSize">{{ extensionAndSize }}</span>
  </div>
</a>
